import { Link } from "react-router-dom";
import React from "react";
import LinkCard from "../profile/linkCard";

export default function Menu() {
  return (
    <menu className="menu">
      <div className="menu-banner"></div>
      <div className="menu-box">
        <div className="menu-link">
          <ion-icon name="location"></ion-icon>
          <h4>We deliver all over PATNA</h4>
        </div>
        <div className="menu-link">
          <ion-icon name="bicycle"></ion-icon>
          <h4>Same day delivery </h4>
        </div>

        <LinkCard
          link="/membership"
          title="SBG Membership"
          icon={<ion-icon name="people"></ion-icon>}
        />
        <LinkCard
          link="/shop-on-whatsapp"
          title="Shop on Whatsapp"
          icon={<ion-icon name="logo-whatsapp"></ion-icon>}
        />
        <LinkCard
          link="/sell-on-sabjigrocery/sbg-marketplace"
          title="Sell on SabjiGrocery"
          icon={<ion-icon name="storefront"></ion-icon>}
        />
        <LinkCard
          link="/about-us/faq"
          title="FAQs"
          icon={<ion-icon name="help-circle"></ion-icon>}
        />
        <LinkCard
          link="/b2b"
          title="B2B"
          icon={<ion-icon name="bus"></ion-icon>}
        />
        <LinkCard
          link="/about-us/sbg"
          title="About Us"
          icon={<ion-icon name="information-circle"></ion-icon>}
        />
        <LinkCard
          link="/about-us/support"
          title="Support"
          icon={<ion-icon name="heart-circle"></ion-icon>}
        />
        <LinkCard
          link="/about-us/privacy-policy"
          title="Privacy-policy"
          icon={<ion-icon name="library"></ion-icon>}
        />
        <LinkCard
          link="/about-us/terms-and-conditions"
          title="Terms and Conditions"
          icon={<ion-icon name="newspaper"></ion-icon>}
        />

        <LinkCard
          link="/about-us/return-policy"
          title="Return & Refund Policy"
          icon={<ion-icon name="cash"></ion-icon>}
        />
      </div>
    </menu>
  );
}
